import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { faAlignJustify, faAlignRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import Logo from '../../Image/logo.png'
const NavbarCom = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const handleToggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const handleNavLinkClick = () => {
        setMobileMenuOpen(false);
    };

    return (
        <Header>
            <DarkCyanBackground />
            <Nav>
                <NavLogo>
                    <NavLink className="div"  to="/" onClick={handleNavLinkClick}>
                        <img className="logo" src={Logo} alt=""/>

                        <p>
                            Asad
                        </p>
                    </NavLink>
                </NavLogo>
                <NavList mobileMenuOpen={mobileMenuOpen}>
                    <NavItem>
                        <NavLink to="/" onClick={handleNavLinkClick}>Home</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/works" onClick={handleNavLinkClick}>Works</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/comparision" onClick={handleNavLinkClick}>Comparison</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/skills" onClick={handleNavLinkClick}>Skills</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/about" onClick={handleNavLinkClick}>About</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink to="/contacts" onClick={handleNavLinkClick}>Contacts</NavLink>
                    </NavItem>
                </NavList>
                <NavActions>
                    <ToggleMobileButton onClick={handleToggleMobileMenu}>
                        {mobileMenuOpen ? (
                            <FontAwesomeIcon className="burger" icon={faAlignRight} />
                        ) : (
                            <FontAwesomeIcon className="burger" icon={faAlignJustify} />
                        )}
                    </ToggleMobileButton>
                </NavActions>
            </Nav>
        </Header>
    );
};

const Header = styled.header`
  position: relative;
  width: 100%;

`;

const NavLogo = styled.div`
  width: 70%;
  .div{
    display: flex;
    align-items: center;
    
  }
.logo{
  width: 40px;
  &:hover{
    opacity: 0.5;
  }

}
`;

const DarkCyanBackground = styled.div`
  background-color: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  z-index: -1;
`;

const Nav = styled.nav`
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 1.2%;
  background-color: black;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
`;

const NavList = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin: 0;
  width: 45%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    top: 100px;
    left: 0;
    background-color: black;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    width: 100%;
    padding: 20px;
    opacity: 0.9;
    display: ${({ mobileMenuOpen }) => (mobileMenuOpen ? 'flex' : 'none')};
  }
`;

const NavItem = styled.li``;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #03ff2c;
  font-size: 16px;
  transition: color 0.3s;
  
  font-family: Consolas, monospace; 
  &:hover {
    color: darkgreen;
  }
  p{
    font-size: 23px;
    font-weight: 100;
    text-decoration: none;
    color: #03ff2c;
    font-family: Consolas, monospace;
    &:hover {
      color: darkgreen;
    }
  }
`;

const NavActions = styled.div`
  display: flex;
  gap: 20px;
`;

const ToggleMobileButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
    color: black;
  }
  &:hover {
    color: darkgreen;
  }
  .burger {
    color: #03ff2c;
  }
`;

const Main = styled.main`
  margin-top: 100px;
  padding: 20px;
`;

export default NavbarCom;
